import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { View } from '../../../../components/Common/react-native-components';
import EmojiMap from '../../../Overview/components/OverviewComp/components/EmojiMap';
import { makeJsonFromMetricData } from '../../../../utils/transformChartsAndTableData';
import { handleHighChartsExport } from '../../../Overview/utils';
import { useTransformSentimentChartData } from './useTransformSentimentChartData';
import HighchartsReactTooltip from './HighchartsReactTooltip';

const SentimentChart = forwardRef(({ data, widgetData }, ref) => {
  const chartRef = useRef(null);

  const actionButtonClick = e => {
    handleHighChartsExport(e, chartRef, widgetData);
  };

  useImperativeHandle(ref, () => ({ actionButtonClick }));

  let dd = makeJsonFromMetricData(data);

  const [hoveredPoint, setHoveredPoint] = useState(null);

  let { options } = useTransformSentimentChartData(dd, setHoveredPoint);

  return (
    <>
      <View style={{ flexDirection: 'row' }}>
        <View
          style={{
            width: 60,
            borderRightWidth: 1,
            paddingVertical: 20,
            borderColor: 'rgb(206, 212, 218)',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <EmojiMap type='HAPPY' />
          <EmojiMap type='SAD' />
        </View>
        <View style={{ flex: 1 }}>
          <HighchartsReact ref={chartRef} highcharts={Highcharts} options={options} />
          {chartRef.current?.chart && (
            <HighchartsReactTooltip hoveredPoint={hoveredPoint} chart={chartRef.current.chart} />
          )}
        </View>
      </View>
    </>
  );
});

export default SentimentChart;
